/** Redirects the user to the mobile app if on a mobile device */
export function redirectToMobileApp (email?: string) {
  if (!isMobile()) {
    return false;
  }
  let url = `${process.env.APP_MOBILE}/signin`;
  if (email) {
    const encodedEmail = btoa(email);
    const urlSearchParams = new URLSearchParams({ email: encodedEmail });
    url += `?${urlSearchParams.toString()}`;
  }
  window.location.href = url;
  return true;
}

function isIOS () {
  return /iP(hone|ad|od)/.test(navigator.userAgent);
}

function isAndroid () {
  return /Android/.test(navigator.userAgent);
}

function isMobile () {
  return isIOS() || isAndroid();
}

function redirectToIOSAppDownload () {
  window.location.href = `https://apps.apple.com/us/app/redlist/id${process.env.IOS_APP_ID}`;
}

function redirectToAndroidAppDownload () {
  window.location.href = `https://play.google.com/store/apps/details?id=${process.env.ANDROID_PACKAGE_NAME}`;
}

function redirectToWebApp () {
  window.location.href = process.env.APP_WEBAPP;
}

/** Redirects the user to download the mobile app if on a mobile device, otherwise redirects to the web app */
export function redirectToMobileAppDownloadOrWebApp () {
  if (isIOS()) {
    redirectToIOSAppDownload();
  } else if (isAndroid()) {
    redirectToAndroidAppDownload();
  } else {
    redirectToWebApp();
  }
}
